// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"1a39bf7b","243":"e43f7f48","300":"ddf8d2ab","608":"2221ffba","635":"423a816d","705":"e5493c72","772":"ca60a960","798":"7944e3c4","909":"687d096f"}[chunkId] + ".chunk.js";
};